import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export default function EventNote(props:any) {
  return (
    <SvgIcon {...props}>
      <path d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7 11h10v2H7v-2z" />
    </SvgIcon>
  )
}
